import DefaultSignupStrategy from './defaultSignupStrategy';

const background = require('../../../../../assets/images/mm-landing.jpg');
const logo = require('../../../../../assets/images/mm-dual-logos.png');

export default class MidstateMassiveSignupStrategy extends DefaultSignupStrategy {
  constructor() {
    super();

    this.isDefault = false;
    this.hasLogo = true;
    this.logo = logo;
    this.logoAltText = '';
    this.pageClass = 'col-8 card card-signup brooks';
    this.header = 'Welcome Midstate Massive Runners';
    this.headline = `You are receiving a free 60-day trial of PWR Lab, courtesy of Midstate Massive.
              PWR Lab is an easy-to-use but immensely powerful tool for enhancing your training
              and reducing your risk of injury. Sign up, sync your Suunto or Garmin, and get
              started!<br/><br/><a href="https://ultrasignup.com/register.aspx?did=67150" target="_blank">
              Register for the Midstate Massive</a> <em>and</em> sign up for PWR Lab to unlock
              training tips and stats, emailed from PWR Lab and based on data generated by real
              Midstate Massive participants.`;

    this.showCoupon = false;
    this.pageStyle = '';
    this.h3Style = 'margin-bottom: 20px;';
    this.rootStyle = `
      background-image: url(${background});
      background-size: cover;
      min-height: 130vh;
      background-attachment: initial;
      overflow-y: initial;
  `.replace(/\n/g, '');

    this.logoStyle = 'width: 80%;';
  }
}
